import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
const HeroBannerSection = ({ data, loading }) => {
  const navigate = useNavigate();

  return (
    <div className="hero-banner-section">
      <Container className="d-flex justify-content-center">
        <Card>
          <h2 dangerouslySetInnerHTML={{ __html: data?.title || "" }} />
          <p>{data?.subtitle || ""}</p>
          <Button
            className="custom-bttn style-3 w-100 w-md-50"
            onClick={() => navigate('/get-pre-qualified', { state: { hideHero: true } })}
          >
            {data?.btn_name || "Get Pre-qualified"}
          </Button>
          <p
            className="mb-0"
            dangerouslySetInnerHTML={{ __html: data?.description || "" }}
          />
        </Card>
      </Container>
    </div>
  );
};

export default HeroBannerSection;
